import type {
  DealItemGenericProperty,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';

const COLOR_OPTION_NAMES = new Set([
  'couleur',
  'couleurs',
  'color',
  'colors',
  'coloris',
  'colour',
  'colours',
  'colore',
  'colori',
  'colores',
  'cor',
  'cores',
  'farbe',
  'farben',
  'kleur',
  'kleuren',
]);

export const findColorOption = (
  options: readonly DealItemGenericProperty[] | null | undefined
): DealItemGenericProperty | undefined =>
  options?.find((option) =>
    COLOR_OPTION_NAMES.has(option.name.trim().toLocaleLowerCase())
  );

const haveSameImages = (
  images: readonly string[],
  referenceImages: readonly string[]
): boolean =>
  images.length === referenceImages.length &&
  images.every((image, index) => image === referenceImages[index]);

/**
 * Finds sibling variants that can inherit a newly-added color because they use
 * the exact same image set and do not already carry a color option.
 */
export const findSameVisualVariantsMissingColor = (
  products: readonly DealItemWithVersions[],
  sourceProductId: string
): DealItemWithVersions[] => {
  const source = products.find((product) => product.id === sourceProductId);
  if (!source || source.activeVersion.images.length === 0) return [];

  return products.filter((product) => {
    if (product.id === source.id) return false;
    if (product.activeVersion.isSelected !== source.activeVersion.isSelected) {
      return false;
    }

    return (
      product.activeVersion.name === source.activeVersion.name &&
      haveSameImages(
        product.activeVersion.images,
        source.activeVersion.images
      ) &&
      !findColorOption(product.activeVersion.options)
    );
  });
};
